import getIntlDateTimeFormatter from './getIntlDateTimeFormatter';

export default getIntlDateTimeFormatter;
export * from './getIntlDateTimeFormatter';
